<div class="container main" id="skrollr-body">
  <div class="col-md-12 col-sm-12 col-xs-12">
    <h1 class="about">{{ 'privacyPage.title' | translate }}</h1>
    <h3><strong>{{ 'privacyPage.intro.heading' | translate }}</strong></h3>
    <p>
      {{ 'privacyPage.intro.para1' | translate }}
    </p>
    <p>
      {{ 'privacyPage.intro.para2Before' | translate }}
      <a [attr.aria-label]="'privacyPage.intro.homeLink.ariaLabel' | translate" c11n-link class="c11n-link" [routerLink]="'/home' | langLink"><span
          class="c11n-link__text">{{ 'privacyPage.intro.homeLink.text' | translate }}</span></a>
      {{ 'privacyPage.intro.para2After' | translate }}
      <a c11n-link [routerLink]="'/studentprivacy' | langLink" [attr.aria-label]="'privacyPage.intro.studentPrivacyLink.ariaLabel' | translate">{{ 'privacyPage.intro.studentPrivacyLink.text' | translate }}</a>.
    </p>
    <p>
      {{ 'privacyPage.intro.para3Before' | translate }}
      <a c11n-link [routerLink]="'/terms' | langLink" [attr.aria-label]="'privacyPage.intro.termsLink.ariaLabel' | translate">{{ 'privacyPage.intro.termsLink.text' | translate }}</a>{{ 'privacyPage.intro.para3After' | translate }}
    </p>

    <h3><strong>{{ 'privacyPage.personalInfo.heading' | translate }}</strong></h3>
    <p>
      {{ 'privacyPage.personalInfo.intro' | translate }}
    </p>

    <h4>
      <strong><em>{{ 'privacyPage.personalInfo.fromSchools.heading' | translate }}</em></strong>
    </h4>
    <ul>
      <li>{{ 'privacyPage.personalInfo.fromSchools.li1' | translate }}</li>
      <li>{{ 'privacyPage.personalInfo.fromSchools.li2' | translate }}</li>
    </ul>

    <h4>
      <strong><em>{{ 'privacyPage.personalInfo.fromTeachers.heading' | translate }}</em></strong>
    </h4>
    <ul>
      <li>{{ 'privacyPage.personalInfo.fromTeachers.li1' | translate }}</li>
      <li>{{ 'privacyPage.personalInfo.fromTeachers.li2' | translate }}</li>
      <li>{{ 'privacyPage.personalInfo.fromTeachers.li3' | translate }}</li>
      <li>{{ 'privacyPage.personalInfo.fromTeachers.li4' | translate }}</li>
      <li>{{ 'privacyPage.personalInfo.fromTeachers.li5' | translate }}</li>
      <li>{{ 'privacyPage.personalInfo.fromTeachers.li6' | translate }}</li>
    </ul>

    <h4><strong><em>{{ 'privacyPage.personalInfo.fromStudents.heading' | translate }}</em></strong></h4>
    <p>
      {{ 'privacyPage.personalInfo.fromStudents.intro' | translate }}
    </p>
    <ul>
      <li>{{ 'privacyPage.personalInfo.fromStudents.li1' | translate }}</li>
      <li>{{ 'privacyPage.personalInfo.fromStudents.li2' | translate }}</li>
      <li>{{ 'privacyPage.personalInfo.fromStudents.li3' | translate }}</li>
    </ul>
    <p>
      {{ 'privacyPage.personalInfo.fromStudents.outro' | translate }}
      <strong><a c11n-link [routerLink]="'/studentprivacy' | langLink" [attr.aria-label]="'privacyPage.personalInfo.fromStudents.outroLink.ariaLabel' | translate">{{ 'privacyPage.personalInfo.fromStudents.outroLink.text' | translate }}</a>.</strong>
    </p>

    <h3><strong>{{ 'privacyPage.tracking.heading' | translate }}</strong></h3>
    <p>
      {{ 'privacyPage.tracking.intro' | translate }}
    </p>
    <ul>
      <li>{{ 'privacyPage.tracking.li1' | translate }}</li>
      <li>{{ 'privacyPage.tracking.li2' | translate }}</li>
      <li>{{ 'privacyPage.tracking.li3' | translate }}</li>
      <li>{{ 'privacyPage.tracking.li4' | translate }}</li>
      <li>{{ 'privacyPage.tracking.li5' | translate }}</li>
    </ul>
    <p>{{ 'privacyPage.tracking.para2' | translate }}</p>
    <p>{{ 'privacyPage.tracking.para3' | translate }}</p>
    <p>{{ 'privacyPage.tracking.para4' | translate }}</p>
    <ul>
      <li>{{ 'privacyPage.tracking.cookieLi1' | translate }}</li>
      <li>{{ 'privacyPage.tracking.cookieLi2' | translate }}</li>
      <li>{{ 'privacyPage.tracking.cookieLi3' | translate }}</li>
      <li>{{ 'privacyPage.tracking.cookieLi4' | translate }}</li>
    </ul>

    <h3><strong>{{ 'privacyPage.useDisclosure.heading' | translate }}</strong></h3>
    <h4><strong><em>{{ 'privacyPage.useDisclosure.howWeUse.heading' | translate }}</em></strong></h4>
    <p>
      {{ 'privacyPage.useDisclosure.howWeUse.intro' | translate }}
    </p>
    <ul>
      <li>{{ 'privacyPage.useDisclosure.howWeUse.li1' | translate }}</li>
      <li [innerHTML]="'privacyPage.useDisclosure.howWeUse.li2' | translate"></li>
      <li>{{ 'privacyPage.useDisclosure.howWeUse.li3' | translate }}</li>
      <li>{{ 'privacyPage.useDisclosure.howWeUse.li4' | translate }}</li>
      <li>{{ 'privacyPage.useDisclosure.howWeUse.li5' | translate }}</li>
      <li>{{ 'privacyPage.useDisclosure.howWeUse.li6' | translate }}</li>
      <li>{{ 'privacyPage.useDisclosure.howWeUse.li7' | translate }}</li>
      <li>{{ 'privacyPage.useDisclosure.howWeUse.li8' | translate }}</li>
      <li>{{ 'privacyPage.useDisclosure.howWeUse.li9' | translate }}</li>
    </ul>

    <h4><strong><em>{{ 'privacyPage.useDisclosure.toWhom.heading' | translate }}</em></strong></h4>
    <p [innerHTML]="'privacyPage.useDisclosure.toWhom.serviceProviders' | translate"></p>
    <p [innerHTML]="'privacyPage.useDisclosure.toWhom.legalPurposes' | translate"></p>

    <h4><strong><em>{{ 'privacyPage.useDisclosure.retention.heading' | translate }}</em></strong></h4>
    <p>
      {{ 'privacyPage.useDisclosure.retention.intro' | translate }}
    </p>
    <ul>
      <li>{{ 'privacyPage.useDisclosure.retention.li1' | translate }}</li>
      <li>{{ 'privacyPage.useDisclosure.retention.li2' | translate }}</li>
      <li>{{ 'privacyPage.useDisclosure.retention.li3' | translate }}</li>
      <li>{{ 'privacyPage.useDisclosure.retention.li4' | translate }}</li>
    </ul>
    <p>{{ 'privacyPage.useDisclosure.retention.outro' | translate }}</p>

    <h3><strong>{{ 'privacyPage.california.heading' | translate }}</strong></h3>
    <p>
      {{ 'privacyPage.california.intro' | translate }}
    </p>

    <h4><strong><em>{{ 'privacyPage.california.rightToKnow.heading' | translate }}</em></strong></h4>
    <p>
      {{ 'privacyPage.california.rightToKnow.intro' | translate }}
    </p>
    <ul>
      <li>{{ 'privacyPage.california.rightToKnow.li1' | translate }}</li>
      <li>{{ 'privacyPage.california.rightToKnow.li2' | translate }}</li>
      <li>{{ 'privacyPage.california.rightToKnow.li3' | translate }}</li>
      <li>{{ 'privacyPage.california.rightToKnow.li4' | translate }}</li>
      <li>{{ 'privacyPage.california.rightToKnow.li5' | translate }}</li>
      <li>{{ 'privacyPage.california.rightToKnow.li6' | translate }}</li>
      <li>{{ 'privacyPage.california.rightToKnow.li7' | translate }}</li>
    </ul>

    <h4>
      <strong><em>{{ 'privacyPage.california.rightToDelete.heading' | translate }}</em></strong>
    </h4>
    <p>
      {{ 'privacyPage.california.rightToDelete.para' | translate }}
    </p>

    <h4><strong><em>{{ 'privacyPage.california.rightToCorrect.heading' | translate }}</em></strong></h4>
    <p>
      {{ 'privacyPage.california.rightToCorrect.para' | translate }}
    </p>

    <h4><strong><em>{{ 'privacyPage.california.rightToOptOut.heading' | translate }}</em></strong></h4>
    <p>
      {{ 'privacyPage.california.rightToOptOut.para1' | translate }}
    </p>
    <p>
      {{ 'privacyPage.california.rightToOptOut.para2Before' | translate }} <strong><a c11n-link
        href="https://investor.vanguard.com/privacy-center" target="_blank" rel="noopener noreferrer"
        [attr.aria-label]="'privacyPage.california.rightToOptOut.privacyCenterLinkAriaLabel' | translate">{{ 'privacyPage.california.rightToOptOut.privacyCenterLinkText' | translate }}</a></strong>.
    </p>

    <h4><strong><em>{{ 'privacyPage.california.ccpaRequest.heading' | translate }}</em></strong></h4>
    <p [innerHTML]="'privacyPage.california.ccpaRequest.para1' | translate"></p>
    <p [innerHTML]="'privacyPage.california.ccpaRequest.para2' | translate"></p>
    <p>{{ 'privacyPage.california.ccpaRequest.para3' | translate }}</p>

    <h3><strong>{{ 'privacyPage.contactUs.heading' | translate }}</strong></h3>
    <p>
      {{ 'privacyPage.contactUs.para1Before' | translate }}
      <strong><a c11n-link [routerLink]="'/aboutus' | langLink" [queryParams]="{contact: 'true'}" [attr.aria-label]="'privacyPage.contactUs.contactFormLinkAriaLabel' | translate">{{ 'privacyPage.contactUs.contactFormLinkText' | translate }}</a></strong>.
    </p>
    <p [innerHTML]="'privacyPage.contactUs.para2' | translate"></p>

    <h3><strong>{{ 'privacyPage.changes.heading' | translate }}</strong></h3>
    <p>
      {{ 'privacyPage.changes.para' | translate }}
    </p>
    <p><b>{{ 'privacyPage.changes.lastReviewed' | translate }}</b></p>
  </div>
</div>

